import PropTypes from "prop-types"
import styled from "styled-components"

import SearchInput from "./SearchInput"
import ContainerWithSideBar from "./ContainerWithSideBar"
import Header from "./Header"
import { useNavigate, useParams } from "react-router-dom"
import { getSectionBySlug } from "../../lib/cmsFaqs"
import QuestionLink from "./QuestionLink"

const Title = styled.h1`
  text-align: center;
  flex: 1;
`

const FaqsSection = ({ isMobile }) => {
  const params = useParams()

  const section = getSectionBySlug(params?.sectionSlug)

  const navigate = useNavigate()

  if (!section) {
    navigate("/help")
  }

  const sectionsFaqs = section.faqs

  return (
    <div>
      <Header>
        <Title>{`${section.title} FAQs`}</Title>
      </Header>
      <SearchInput />
      <ContainerWithSideBar isMobile={isMobile}>
        <div>
          {sectionsFaqs && <span>{`${sectionsFaqs.length} Questions`}</span>}
          {sectionsFaqs?.map((faq) => (
            <QuestionLink
              key={faq.id}
              size="h3"
              sectionSlug={section.slug}
              faq={faq}
            />
          ))}
        </div>
      </ContainerWithSideBar>
    </div>
  )
}

FaqsSection.propTypes = {
  isMobile: PropTypes.bool,
}

export default FaqsSection
